export enum TenaJobType {
    Default = 'Default',
    AskTheDoctor = 'Ask the doctor',
    BrochureOrder = 'Brochure order',
    ContactUs = 'Contact us',
    SampleOrder = 'Sample order',
    Newsletter = 'Newsletter'
}